const TruncatedTd = ({ children, length = 20 }) => {
    const text = children?.toString() || "";
    const truncated = text.length > length ? text.substring(0, length) + "…" : text;

    return (
        <td title={text}>
            {truncated}
        </td>
    );
};

export default TruncatedTd;
